import React, { useState, useRef } from 'react';
import api from '~/services/api';
import { toast } from 'react-toastify';
// import history from '~/services/history';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
} from 'reactstrap';
/* eslint-disable react/no-array-index-key */

export default function ConfirmPickupModal({
  isOpen,
  toggle,
  confirmationCode,
  saleId,
  role,
  onConfirmSuccess,
}) {
  const [inputs, setInputs] = useState(['', '', '', '']);
  const [error, setError] = useState(null);
  const inputRefs = useRef([]);

  const handleInputChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);
    setError(null);

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !inputs[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async () => {
    const codeEntered = inputs.join('');

    if (codeEntered === confirmationCode) {
      try {
        await api.patch(`${role}/carts/${saleId}/confirm`, {
          confirmation_code: codeEntered,
        });

        toast.success('Código confirmado! Venda finalizada.');
        toggle();
        setInputs(['', '', '', '']);
        setError(null);

        if (onConfirmSuccess) {
          onConfirmSuccess();
        }
        // history.push('/');
        // window.location.reload();
      } catch (err) {
        const errorMessage =
          err?.response?.data?.message ||
          'Erro ao confirmar a retirada. Tente novamente ou entre em contato com o suporte.';
        setError(errorMessage);
      }
    } else {
      setError('Código inválido. Verifique com o cliente e tente novamente.');
    }
  };

  const handleClose = () => {
    toggle();
    setInputs(['', '', '', '']);
    setError(null);
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Confirmação de Retirada</ModalHeader>
      <ModalBody>
        <p>
          Para confirmar a retirada do pedido, o cliente deve informar o código
          de 4 dígitos gerado no checkout. Digite o código abaixo:
        </p>
        <Row className="justify-content-center mb-3">
          {inputs.map((value, index) => (
            <Col xs={3} key={index}>
              <Input
                type="text"
                maxLength={1}
                className="text-center font-weight-bold font-size-24"
                value={value}
                onChange={e => handleInputChange(index, e.target.value)}
                onKeyDown={e => handleKeyDown(e, index)}
                innerRef={ref => {
                  inputRefs.current[index] = ref;
                }}
              />
            </Col>
          ))}
        </Row>
        {error && <p className="text-danger text-center">{error}</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Confirmar Retirada
        </Button>
      </ModalFooter>
    </Modal>
  );
}
